enum StepEnum {
  general,
  profile,
  finish
}

export default StepEnum;
